import type { HashIndicator, ReputationReport } from "@sage/shared";
import type { LookupFailure } from "./reputation-client";

export type ReportVisibility = "public" | "private";

export type LookupStatus =
  | { kind: "idle" }
  | { kind: "invalid"; message: string }
  | { kind: "loading"; hash: HashIndicator }
  | { kind: "success"; report: ReputationReport; visibility: ReportVisibility }
  | { kind: "unknown"; report: ReputationReport; visibility: ReportVisibility }
  | { kind: "unauthorized"; message: string }
  | { kind: "quota_exceeded"; message: string }
  | { kind: "billing_unavailable"; message: string }
  | { kind: "network_error"; message: string }
  | { kind: "not_supported"; message: string };

export function mapLookupFailure(error: LookupFailure): LookupStatus {
  if (error.kind === "unauthorized") {
    return { kind: "unauthorized", message: error.message };
  }
  if (error.kind === "quota_exceeded") {
    return { kind: "quota_exceeded", message: error.message };
  }
  if (error.kind === "billing_unavailable") {
    return { kind: "billing_unavailable", message: error.message };
  }
  return { kind: "network_error", message: error.message };
}
